import { useDelete, useList, useNavigation } from "@refinedev/core";
import { Button, Popconfirm, Space, Table, message } from "antd";
import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { MedicineDigest } from "./types";

export const MedicineDigestsTable = () => {
  const { push } = useNavigation();
  const { data, isLoading, refetch } = useList<MedicineDigest>({
    resource: "medicine-digests",
    dataProviderName: "medicineDigestsDataProvider",
  });
  const { mutate: deleteDigest, isLoading: deletingDigest } = useDelete();

  const digests = data?.data || [];

  const handleDelete = (digest: MedicineDigest) => {
    deleteDigest(
      {
        dataProviderName: "medicineDigestsDataProvider",
        resource: "medicine-digests",
        id: digest.id,
      },
      {
        onSuccess: () => {
          message.success("Дайджест удален");
          refetch();
        },
        onError: (error: any) => {
          message.error(error?.message || "Не удалось удалить дайджест");
        },
      }
    );
  };

  return (
    <Table<MedicineDigest>
      title={() => (
        <Space>
          <strong>Дайджесты</strong>
          <Button
            size="small"
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => push("/medicine/materials/digests/create")}
          >
            Добавить дайджест
          </Button>
        </Space>
      )}
      dataSource={digests}
      loading={isLoading}
      rowKey="id"
      pagination={false}
      locale={{
        emptyText: <div style={{ margin: 56 }}>Дайджесты отсутствуют</div>,
      }}
    >
      <Table.Column<MedicineDigest>
        dataIndex="title"
        key="title"
        title="Название"
      />
      <Table.Column<MedicineDigest>
        dataIndex="date"
        key="date"
        title="Дата"
        width={160}
      />
      <Table.Column<MedicineDigest>
        dataIndex="text"
        key="text"
        title="Текст"
        render={(value) => (
          <span
            style={{
              overflow: "hidden",
              display: "-webkit-box",
              WebkitBoxOrient: "vertical",
              WebkitLineClamp: 3,
            }}
          >
            {value}
          </span>
        )}
      />
      <Table.Column<MedicineDigest>
        width={220}
        fixed="right"
        key="actions"
        title="Действия"
        render={(_, record) => (
          <Space size={8} direction="vertical" style={{ width: "100%" }}>
            <Button
              size="small"
              icon={<EditOutlined />}
              onClick={() =>
                push(`/medicine/materials/digests/edit/${record.id}`)
              }
              block
            >
              Редактировать
            </Button>
            <Popconfirm
              title="Удалить дайджест?"
              okText="Удалить"
              cancelText="Отмена"
              onConfirm={() => handleDelete(record)}
            >
              <Button
                danger
                size="small"
                icon={<DeleteOutlined />}
                loading={deletingDigest}
                block
              >
                Удалить
              </Button>
            </Popconfirm>
          </Space>
        )}
      />
    </Table>
  );
};
